var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDaughter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.972,
    height: 28.854,
    viewBox: "0 0 27.972 28.854",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_191208",
    "data-name": "Group 191208",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_176458",
    "data-name": "Group 176458",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_173777",
    "data-name": "Path 173777",
    d: "M28.683,9.929c-.667-.462-1.778-1.233-1.846-2.057C26.468,3.308,23.12,0,18.883,0a8.087,8.087,0,0,0-7.957,7.914c-.039.971-1.437,1.853-2.186,2.326-.606.38-1.29.814-1.061,1.652a1.178,1.178,0,0,0,1.219.846,15.707,15.707,0,0,1,5.083,1.638.011.011,0,0,1,.007,0c.165.075,5.158,2.7,9.341.229.351-.158.71-.315,1.068-.48a19.227,19.227,0,0,1,4.255-1.566,1.227,1.227,0,0,0,1.122-.921c.194-.824-.459-1.276-1.09-1.713M23.525,12.2c-1.738.785-3.541,1.6-4.642,1.6a13.206,13.206,0,0,1-4.047-1.358,31.548,31.548,0,0,0-3.545-1.394A4.254,4.254,0,0,0,13.048,8a5.97,5.97,0,0,1,5.835-5.878c3.1,0,5.559,2.491,5.839,5.921A4.312,4.312,0,0,0,26.5,10.95c-.961.341-1.975.8-2.971,1.247",
    transform: "translate(-4.897)",
    fill: "#f26422"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173778",
    "data-name": "Path 173778",
    d: "M27.972,54.975V56.23H0V54.975A14.058,14.058,0,0,1,6.864,42.964a10.905,10.905,0,0,0,2.591,1.484A11.563,11.563,0,0,0,2.581,53.72H25.391a11.532,11.532,0,0,0-7.326-9.455,10.87,10.87,0,0,0,2.527-1.6,14.041,14.041,0,0,1,7.38,12.305",
    transform: "translate(0 -27.376)",
    fill: "#f26422"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaughter);
export default __webpack_public_path__ + "static/media/daughter.1809e9c2ed0cc57a4aa22112ac812da1.svg";
export { ForwardRef as ReactComponent };